import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "midTitle text-center mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "form-group"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  class: "form-group"
}
const _hoisted_6 = { class: "form-control" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 2,
  class: "buttonsSelector my-4"
}
const _hoisted_11 = { class: "buttonsTitle" }
const _hoisted_12 = { class: "buttons" }
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "col-sm-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "text-center mt-4" }
const _hoisted_21 = { class: "text-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_calendar_appuntamenti = _resolveComponent("calendar-appuntamenti")!
  const _component_op_date = _resolveComponent("op-date")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.booking)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            localizedKey: "Sposta prenotazione:",
            text: "Sposta prenotazione:"
          }))
        : (_openBlock(), _createBlock(_component_localized_text, {
            key: 1,
            localizedKey: "Prenota per:",
            text: "Prenota per:"
          })),
      _createTextVNode(" " + _toDisplayString(_ctx.customer.personalData.completeName), 1)
    ]),
    (!_ctx.booking)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Seleziona professione",
              text: "Seleziona professione"
            })
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedVoucher) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distinctVouchers, (item, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: item
              }, _toDisplayString(item.profession.name), 9, _hoisted_4))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.selectedVoucher]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Seleziona professione",
              text: "Seleziona professione"
            })
          ]),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.booking.professione.name), 1)
        ])),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Seleziona dottore",
          text: "Seleziona dottore"
        })
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vm.user) = $event)),
        disabled: !!_ctx.booking
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctors, (item, i) => {
          return (_openBlock(), _createElementBlock("option", {
            key: i,
            value: item
          }, _toDisplayString(item && item.name), 9, _hoisted_9))
        }), 128))
      ], 8, _hoisted_8), [
        [_vModelSelect, _ctx.vm.user]
      ])
    ]),
    (_ctx.$store.state.user.identifier == _ctx.vm.user.identifier || _ctx.$store.state.isAdmin())
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_localized_text, {
              localizedKey: "Modalità prenotazione",
              text: "Modalità prenotazione"
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: _normalizeClass(["button", { selected: _ctx.bookingMode == 'slot' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.bookingMode = 'slot'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Usa gli slot",
                text: "Usa gli slot"
              })
            ], 2),
            _createElementVNode("button", {
              class: _normalizeClass(["button", { selected: _ctx.bookingMode == 'free' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.bookingMode = 'free'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data e ora liberi",
                text: "Data e ora liberi"
              })
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.bookingMode == 'slot' && _ctx.vm.user && _ctx.vm.user.identifier)
      ? (_openBlock(), _createBlock(_component_calendar_appuntamenti, {
          key: 3,
          doctorIdentifier: _ctx.vm.user.identifier,
          professionIdentifier: _ctx.professionIdentifier,
          customer: _ctx.customer,
          hideNewBookingButton: true,
          voucher: _ctx.selectedVoucher,
          booking: _ctx.booking
        }, null, 8, ["doctorIdentifier", "professionIdentifier", "customer", "voucher", "booking"]))
      : _createCommentVNode("", true),
    (_ctx.bookingMode == 'free')
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data",
                text: "Data"
              })
            ]),
            _createVNode(_component_op_date, {
              class: "form-control",
              modelValue: _ctx.vm.date,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.vm.date) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Orario inizio",
                    text: "Orario inizio"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.vm.fasciaOraria.from) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.vm.fasciaOraria.from]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Orario fine",
                    text: "Orario fine"
                  })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.vm.fasciaOraria.to) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.vm.fasciaOraria.to]
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-success",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.makePrenotazione && _ctx.makePrenotazione(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Conferma",
                text: "Conferma"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Chiudi",
          text: "Chiudi"
        })
      ])
    ])
  ]))
}